import { disabledMarketItems } from '@components/arsenal/playerMarket/PlayerMarket';
import { HoverItem, HoverMenu } from '@components/helpers/HoverMenu';
import { SellItem } from '@components/arsenal/playerMarket/SellItem';
import { useTranslation } from 'react-i18next';
import { getItemColor } from '@helpers/items';
import { Modal } from '@components/ui/Modal';
import * as Shared from '@shared/lib';
import { useState } from 'react';

interface InventoryItemProps {
  name: string;
  amount: number;
  index: number;
};

export function InventoryItem({ name, amount, index }: InventoryItemProps) {
  const [showSell, setShowSell] = useState(false);

  const { t } = useTranslation(undefined, { keyPrefix: 'Items' });

  const getClasses = () => {
    const base = index % 2 === 0 ? 'border-r-1' : '';
    const added = index % 3 !== 2 ? 'lg:border-r-1' : '';
    return `${base} ${added}`;
  };

  const cannotSell = () => {
    const data = Shared.dropData.find(i => i.key === name);
    return !data || 'crafting' in data || disabledMarketItems.includes(data.id);
  };

  const sellItem = () => setShowSell(true);

  const data = Shared.dropData.find((item) => item.key === name);
  if (!data) return null;

  const hoverItems: HoverItem[] = [
    { label: t('sell'), className: 'btn-active', onClick: sellItem }
  ];

  return (
    <>
      <Modal onRequestClose={() => setShowSell(false)} title={t('sellItem')} isOpen={showSell}>
        <SellItem onClose={() => setShowSell(false)} name={name} />
      </Modal>

      <HoverMenu disabled={cannotSell()} items={hoverItems}>
        <div className={`${getClasses()} inventory-item`}>
          <div className="bg-1" />
          <div className="h-10 flex items-center" >
            <img
              className="blur-animation max-w-10 max-h-10"
              src={`/assets/items/${name}.avif`}
              alt={name}
            />
          </div>
          <div className="bg-2" />

          <div className="text-container">
            <p className={getItemColor(data)}>{t(name)}</p>
          </div>

          <p className="amount">{amount}</p>
        </div>
      </HoverMenu>
    </>
  );
}